import * as React from "react";
import { FastField } from "formik";
import { Checkbox, ColorPicker, FieldOpeningHoursV2, FormGroup, SelectServices, Switch } from "@lib/components";
import { Input } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { inject, observer } from "mobx-react";
import { ModalContent } from "@lib/components";
import { Modal } from "@lib/components";
import { TabSelect, SelectAdv, FieldOpeningHours } from "@lib/components";
import { CoreUtils, DataLocales, getId, ListOrderTimesOptions, ListServicesOptionsNoB } from "@lib/common";
import _cloneDeep from "lodash/cloneDeep";
import { MobxComponent } from "../../../../../mobx/components";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { MenuItemText } from "../menus/layout/floating-button";
import { IconDelete, IconGreenEllipse, IconHelp, IconRedEllipse } from "../../../../components/v2/icons";
import { SettingsFormGroup, SettingsFormGroupInput, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsFormInputContainer, SettingsSwitchContainer, SettingsActionButtonContainer, SettingsActionButtonWrapper, OptionalText } from "../settings-v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { MenuActionContainer, MenuActionItem, MenuColorBodyWrapper, MenuColorColorPickerText, MenuColorColorPickerWrapper, MenuColorDescription, MenuColorFormGroup, MenuColorLabel, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuPublishPlatformContainer, MenuServiceTypeContainer, MenuServiceTypeItem, MenuToggleContainer, MenuToggleText } from "../../../../components/v2/layout.c";
import { PRESET_COLORS } from "../../../../components/v2/menucolor";
import { runOnceNotification } from "../../../../utils/run_once_notification";
import { UI } from "../../../../../core/ui";
import { cloneDeep, isEmpty, isObject } from "lodash";
import { POS_PRINTERS } from "../../../../components/v2/data";
import { toJS } from "mobx";

function availabilityLacksPosOnline(avail: any): boolean {
	if (!avail || typeof avail !== "object") return true;
	const hasPos =
		avail.pos != null && typeof avail.pos === "object" && Object.keys(avail.pos).length > 0;
	const hasOnline =
		avail.online != null && typeof avail.online === "object" && Object.keys(avail.online).length > 0;
	return !hasPos && !hasOnline;
}

function menuDefinesPosOnlineBlocks(conditions: any): {
	defines: boolean;
	pos: any;
	online: any;
} {
	const sourcePos = conditions?.pos;
	const sourceOnline = conditions?.online;
	const defines =
		(sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0) ||
		(sourceOnline != null && typeof sourceOnline === "object" && Object.keys(sourceOnline).length > 0);
	return { defines, pos: sourcePos, online: sourceOnline };
}

function mergeAvailabilityWithPosOnline(resolved: any, sourcePos: any, sourceOnline: any): any {
	return {
		...(resolved && typeof resolved === "object" ? resolved : {}),
		...(sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0
			? { pos: cloneDeep(sourcePos) }
			: {}),
		...(sourceOnline != null && typeof sourceOnline === "object" && Object.keys(sourceOnline).length > 0
			? { online: cloneDeep(sourceOnline) }
			: {}),
	};
}

type FormValues =
	T.Schema.Restaurant.Menu.RestaurantCategory |
	T.Schema.Restaurant.Menu.RestaurantCategoryV2;

interface Props {
	type: "edit" | "create";
	menuIndex: number;
	initialValues: FormValues | null;
	close: () => void;
}

interface State {
	tab: string;
	color: string;
	/** Printer _ids selected for this category (eligible items); state-only until v2 endpoint exists */
	selectedPrinterIdsForEligible: string[];
}

@inject("store") @observer
export class RestaurantFormCategoryV2 extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			tab: "0",
			color: '#000',
			selectedPrinterIdsForEligible: []
		};
	}

	setTab = (tab: string) => {
		this.setState({ tab });
	};

	componentDidUpdate(prevProps: Props) {
		if (this.props.initialValues && !prevProps.initialValues) {
			this.setTab("0");
		}
	}

	assignPrinterToCategory = (printer: any) => {
		this.setState((s) => ({
			selectedPrinterIdsForEligible: s.selectedPrinterIdsForEligible.includes(printer._id)
				? s.selectedPrinterIdsForEligible.filter((id) => id !== printer._id)
				: [...s.selectedPrinterIdsForEligible, printer._id]
		}))
	}

	render() {
		const { type, close } = this.props;
		const { tab } = this.state;
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const activePrinters = store.ably.printers;


		const initialValues = _cloneDeep(this.props.initialValues);
		//@ts-ignore
		if (initialValues && !initialValues.conditions) {
			//@ts-ignore
			initialValues.conditions = {
				hide_unavailable_category: false,
				services: [],
				hours: [],
			};
		}

		let openItems = false;
		let openItemsList: any = [];
		const r = this.injected.store.restaurant;
		// console.log(1)
		if (r && initialValues) {
			// console.log(2)
			// console.log({ initialValues });
			// const filteredMenus = r.menus.filter((menu: any) => menu._id === initialValues.menu_id);
			// if (filteredMenus.length > 0) {
			if (
				// filteredMenus[0]
				// && typeof filteredMenus[0].abacus_open_items === "boolean"
				// && filteredMenus[0].abacus_open_items === true
				r.abacus
				&& typeof r.abacus.abacus_open_items === "boolean"
				&& r.abacus.abacus_open_items === true
			) {
				// console.log(3)
				openItems = true;
				if (
					// filteredMenus[0]
					// && filteredMenus[0].abacus_open_item_list
					r.abacus.abacus_open_item_list
					&& r.abacus.abacus_open_item_list.length > 0
				) {
					// console.log(4)
					const filteredList = r.abacus.abacus_open_item_list.filter(openItem => !['Online Promos', 'Online Fees', 'Online Tips'].includes(openItem.productName))
					openItemsList = filteredList.map(openItemListItem => {
						return {
							value: openItemListItem.productId,
							label: openItemListItem.productName
						}
					});
				}
			}
			// }
		}
		// console.log({ openItems });
		//
		const menuTabs = openItems
			? [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
				{ label: "Open Items", value: "2" },
			]
			: (r?.wpos?.wpos_status ? [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
				{ label: "POS", value: "3" },
			] : [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
			]);
		//
		return (
					<>
					{(activeMobileMenu.name === 'create-category' || activeMobileMenu.name === 'edit-category') &&
					 <TabGroup className='menus'>

						<TabItem
							active={this.state.tab === '0'}
							onClick={() => this.setState({ tab: '0' })}
							style={{ fontSize: '12px' }}
						>
							General
						</TabItem>
						<TabItem
							active={this.state.tab === '1'}
							onClick={() => this.setState({ tab: '1' })}
							style={{ fontSize: '12px' }}
						>
							Conditions
						</TabItem>
						<TabItem
							active={this.state.tab === '2'}
							onClick={() => this.setState({ tab: '2' })}
							style={{ fontSize: '12px' }}
						>
							Open Items
						</TabItem>
						<TabItem
							active={this.state.tab === '3'}
							onClick={() => this.setState({ tab: '3' })}
							style={{ fontSize: '12px' }}
						>
							POS
						</TabItem>
					</TabGroup>}
					<RestaurantForm<FormValues>
				submit={async (r: any, values: FormValues): Promise<{ r: any; update: { $set: { menus: any[] } } }> => {
					const { menuIndex } = this.props;

					r.menus = r.menus || [];
					r.menus[menuIndex] = r.menus[menuIndex] || { categories: [] };
					r.menus[menuIndex].categories = r.menus[menuIndex].categories || [];

					//@ts-ignore
					const printers = values.integrations?.pushpos.printers || [];

					if(printers.length > 0 ) { //propagate dishes / items
						//@ts-ignore
						values.dishes = values.dishes.map(d => {
							//@ts-ignore
							let dpushpos = d.integrations?.pushpos || {};
							if(isEmpty(dpushpos)) {
								return {
									...d,
									integrations: {
										pushpos: {
											...dpushpos,
											printers: printers
										}
									},
								};
							} return d;

						})
					}

					//@ts-ignore
					const existingIndex = r.menus[menuIndex].categories.findIndex((p: FormValues) => p._id === values._id);
					if (existingIndex === -1) {
						r.menus[menuIndex].categories.push(values);
					} else {
						r.menus[menuIndex].categories[existingIndex] = values;
					}

					const update = { $set: { menus: r.menus } };
					return { r, update };
				}}
				customSubmit={
					store.isNewMenuSchema ?
					async (values, form) => {
						const { menuIndex } = this.props;
						const r = this.injected.store.restaurant!;
						const targetMenus = store.isNewMenuSchema ? (r.menus_v2 || []) : r.menus;
						const targetMenu = targetMenus[menuIndex];
						let copyValues = cloneDeep(values);

						//@ts-ignore
						copyValues = {
							...copyValues,
							name: values.name,
							description: values.description,
              				display_name: values.display_name
						}

						//@ts-ignore
						const printers = copyValues?.integrations?.pushpos.printers || [];
						//@ts-ignore
						const categoryConditionsBeforeApi = values.conditions;
						const { defines: categoryDefinesPosOnline, pos: catSourcePos, online: catSourceOnline } =
							menuDefinesPosOnlineBlocks(categoryConditionsBeforeApi);

						try {
							//@ts-ignore
							const existingIndex = targetMenu.categories.findIndex(c => getId(c) === getId(values));
							if ( existingIndex === -1 ) {

								if(store.isNewMenuSchema) {
									// v2 API: conditions → availability, strip client-only fields
									//@ts-ignore
									copyValues.availability = values.conditions;
									//@ts-ignore
									delete copyValues.conditions;
									//@ts-ignore
									delete copyValues.availabilities;
									//@ts-ignore
									delete copyValues._metadata as any;
								}

								const res = await store.api.menu_create_category({
									restaurant_id: r._id,
									menu_id: getId(targetMenu),
									data: copyValues
								});

								if(printers.length > 0 ) { //propagate to items/dishes
									const menuId = getId(targetMenu);
									const categoryId = getId(res);
									
									await Promise.all(
										// @ts-ignore
										targetMenu.items
											.filter((i: any) => i.category_id === categoryId)
											.map(async (d: any) => {
												let dpushpos = d.integrations?.pushpos || {};
												if (isEmpty(dpushpos)) {
													await store.api.menu_partial_update_item({
														restaurant_id: r._id,
														menu_id: menuId,
														category_id: categoryId,
														item_id: getId(d),
														data: {
															integrations: {
																pushpos: { ...dpushpos, printers },
															},
														},
													});
												}
											})
									);
								}

								if (categoryDefinesPosOnline && store.isNewMenuSchema) {
									//@ts-ignore
									const newCatAvailId =
										(res as any)?.availability_id ?? categoryConditionsBeforeApi?.id;
									if (newCatAvailId) {
										const menuId = getId(targetMenu);
										const categoryId = getId(res);
										await Promise.all(
											//@ts-ignore
											targetMenu.items
												.filter((i: any) => i.category_id === categoryId)
												.map(async (d: any) => {
													const itemAid = d.availability_id || newCatAvailId;
													if (itemAid === newCatAvailId) return;
													//@ts-ignore
													const resolved = targetMenu.availabilities?.find(
														(a: any) => a.id === itemAid
													);
													//@ts-ignore
													if (!availabilityLacksPosOnline(resolved)) return;
													await store.api.menu_partial_update_item({
														restaurant_id: r._id,
														menu_id: menuId,
														category_id: categoryId,
														item_id: getId(d),
														data: {
															availability: mergeAvailabilityWithPosOnline(
																resolved,
																catSourcePos,
																catSourceOnline
															),
															availability_id: itemAid,
														},
													});
												})
										);
									}
								}
								UI.notification.success("Category added");
							} else {
								if(store.isNewMenuSchema) {
									// v2 API: conditions → availability, availability_id; strip client-only fields
									//@ts-ignore
									copyValues.availability = values.conditions;
									//@ts-ignore
									copyValues.availability_id = values.conditions?.id;
									//@ts-ignore
									delete copyValues.conditions;
									//@ts-ignore
									delete copyValues.availabilities;
									//@ts-ignore
									delete copyValues._metadata as any;
								}
								await store.api.menu_partial_update_category({
									restaurant_id: r._id,
									menu_id: getId(targetMenu),
									category_id: getId(targetMenu.categories[existingIndex]),
									data: copyValues,
								});

								// For the legacy (v1/original) schema, propagate printer
								// settings down to dishes that don't yet have pushpos
								// integrations configured.
								if ( printers.length > 0 ) {
									const menuId = getId(targetMenu);
									const categoryId = getId(targetMenu.categories[existingIndex]);
									
									await Promise.all(
										// @ts-ignore
										targetMenu.items
											.filter((i: any) => i.category_id === categoryId)
											.map(async (d: any) => {
												let dpushpos = d.integrations?.pushpos || {};
												if (isEmpty(dpushpos)) {
													await store.api.menu_partial_update_item({
														restaurant_id: r._id,
														menu_id: menuId,
														category_id: categoryId,
														item_id: getId(d),
														data: {
															integrations: {
																pushpos: { ...dpushpos, printers },
															},
														},
													});
												}
											})
									);
								}

								if (categoryDefinesPosOnline && store.isNewMenuSchema) {
									const catRow = targetMenu.categories[existingIndex];
									const categoryAvailId =
										categoryConditionsBeforeApi?.id ?? (catRow as any)?.availability_id;
									const categoryId = getId(catRow);
									if (categoryAvailId) {
										const menuId = getId(targetMenu);
										await Promise.all(
											// @ts-ignore
											targetMenu.items
												.filter((i: any) => i.category_id === categoryId)
												.map(async (d: any) => {
													const itemAid = d.availability_id || categoryAvailId;
													if (itemAid === categoryAvailId) return;
													//@ts-ignore
													const resolved = targetMenu.availabilities?.find(
														(a: any) => a.id === itemAid
													);
													if (!availabilityLacksPosOnline(resolved)) return;
													await store.api.menu_partial_update_item({
														restaurant_id: r._id,
														menu_id: menuId,
														category_id: categoryId,
														item_id: getId(d),
														data: {
															availability: mergeAvailabilityWithPosOnline(
																resolved,
																catSourcePos,
																catSourceOnline
															),
															availability_id: itemAid,
														},
													});
												})
										);
									}
								}
								UI.notification.success("Category updated");
							}

							store.setActiveMobileMenu(
								store.activeMobileMenu.referrer.pop()!,
								Array.from(new Set(store.activeMobileMenu.referrer))
							);
							form.setSubmitting(false);
						} catch(e) {
							UI.notification.error(e?.error ?? e?.message ?? 'An error occurred');
							form.setSubmitting(false);
						}
					} : undefined
				}
				validators={{
					name: (values) => {
						if (!values.name) return { name: "This field is required" };
					},
				}}
				initialValues={initialValues}
				onSuccess={() => {
					store.setActiveMobileMenu(
						store.activeMobileMenu.referrer.pop()!,
						Array.from(new Set(store.activeMobileMenu.referrer))
					)
					close()
				}}
				onSuccessMessage={type === "edit" ? "Category edited" : "Category created"}
			>
					{({ form, error, getFieldError }) => {
						const { isSubmitting, setFieldValue } = form;
						const { store } = this.injected;
						const nameValue = form.values.name;
						const descValue = form.values.description;
           				 const displayNameValue = form.values.display_name;

						//@ts-ignore
						const currentAssignPOSPrinters = form.values?.integrations?.pushpos?.printers || [] as number[];

						runOnceNotification(error)
						return (
							<div>
								{this.state.tab === '0' && <>
									<SettingsFormGroup>
										<SettingsFormGroupInput
											 error={(error && getFieldError(form, 'name')) || null}
											 >
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="name"
													render={({ field }: any) => (
														<input
															type="text"
															required
															{...field}
															value={nameValue}
															/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Display Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="display_name"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
                              value={displayNameValue}/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Description</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="description"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
															value={descValue}
															/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										{store.isNewMenuSchema && <>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>This group will be active on<OptionalText>(Required)</OptionalText></SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorFormGroup>
												<MenuColorLabel>POS</MenuColorLabel>
												<MenuToggleContainer>
													<FastField
														name="conditions.pos.enabled"
														render={({ field }: any) => (
													<Switch
														id="pos-enabled"
														checked={field.value}
														onChange={(e) => setFieldValue('conditions.pos.enabled', e.target.checked)}
													/>) } />
												</MenuToggleContainer>
											</MenuColorFormGroup>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorLabel>Select Service Type</MenuColorLabel>
											<SettingsFormInputContainer>
												<FastField
												name="conditions.pos.services"
												render={({ field }: any) => (
													<SelectServices
													type="multi"
													value={field.value || []}
													onChange={(
														options: string[]
													) => {
														setFieldValue(
															"conditions.pos.services",
															options
														);
													}}

													options={ListServicesOptionsNoB}/>
												)} />
											</SettingsFormInputContainer>

										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorFormGroup>
												<MenuColorLabel>Online</MenuColorLabel>
												<MenuToggleContainer>
													<FastField
														name="conditions.online.enabled"
														render={({ field }: any) => (
													<Switch
														id="online-enabled"
														checked={field.value}
														onChange={(e) => setFieldValue('conditions.online.enabled', e.target.checked)}
													/>) } />
												</MenuToggleContainer>
											</MenuColorFormGroup>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorLabel>Select Service Type </MenuColorLabel>
											<SettingsFormInputContainer>
												<FastField
												name="conditions.online.services"
												render={({ field }: any) => (
													<SelectServices
													type="multi"
													value={field.value || []}
													onChange={(
														options: string[]
													) => {
														setFieldValue(
															"conditions.online.services",
															options
														);
													}}

													options={ListServicesOptionsNoB}/>
												)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>

										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Assign printer for this category</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											{r!.settings.printers.length > 0 ?
											r?.settings.printers.map(printer => (
											<MenuActionContainer key={printer._id}>
													<MenuActionItem
													onClick={() => this.assignPrinterToCategory(printer)}
													className="menu-printer-item">
													<div className='printer-checkbox'>
														<Checkbox
															id={printer._id}
															checked={this.state.selectedPrinterIdsForEligible.includes(printer._id)}
															onChange={() => this.assignPrinterToCategory(printer)}
															onClick={(e) => e.stopPropagation()}
														/>
														{printer.name}
													</div>

													{printer.disabled ||
													activePrinters.indexOf(printer.api_key
													) === -1 ? <span>
													<IconRedEllipse />
													Disconnected</span>: <span>
													<IconGreenEllipse />
													Connected </span> }

												</MenuActionItem>
											</MenuActionContainer>
											))

											: <p>no printers yet.</p> }
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Publish this category on other platform</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<MenuPublishPlatformContainer>
												<MenuPublishPlatFormItem>
													<MenuPublishPlatFormItemHeader>
														<MenuPublishPlatFormItemHeaderLabel>Uber</MenuPublishPlatFormItemHeaderLabel>
														<MenuToggleContainer>
															<MenuToggleText>{
																//@ts-ignore
																form.values.external_platforms?.uber?.enabled ? 'On' : 'Off'
															}</MenuToggleText>
															<FastField
																name="conditions.external_platforms.uber.enabled"
																render={({ field }: any) => (
															<Switch
																id="conditions.external_platforms.uber.enabled"
																checked={field.value}
																onChange={(e) => setFieldValue('conditions.external_platforms.uber.enabled', e.target.checked)}
															/>) } />
														</MenuToggleContainer>
													</MenuPublishPlatFormItemHeader>
													<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>
												</MenuPublishPlatFormItem>
												<MenuPublishPlatFormItem>
													<MenuPublishPlatFormItemHeader>
														<MenuPublishPlatFormItemHeaderLabel>Abacus</MenuPublishPlatFormItemHeaderLabel>
														<MenuToggleContainer>
															<MenuToggleText>{
																//@ts-ignore
															form.values.external_platforms?.abacus?.enabled ? 'On' : 'Off'
															}</MenuToggleText>
															<FastField
																name="conditions.external_platforms.abacus.enabled"
																render={({ field }: any) => (
															<Switch
																id="conditions.external_platforms.abacus.enabled"
																checked={field.value}
																onChange={(e) => setFieldValue('conditions.external_platforms.abacus.enabled', e.target.checked)}
															/>) } />
														</MenuToggleContainer>
													</MenuPublishPlatFormItemHeader>
													<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>
												</MenuPublishPlatFormItem>
											</MenuPublishPlatformContainer>
										</SettingsFormGroupInput>
									</> }

									</SettingsFormGroup>
								</>}
								{this.state.tab === '1' && <>
									<SettingsFormGroup>
										<SettingsSwitchContainer>
											<SettingsFormLabelLeftContainer>
												Hide Unavailable Menu
											</SettingsFormLabelLeftContainer>
											<FastField
												name="conditions.hide_unavailable_menu"
												render={({ field }: any) => (
													<Switch
														id="conditions.hide_unavailable_menu"
														checked={field.value || false}
														onChange={(e) => setFieldValue(
															"conditions.hide_unavailable_menu",
															e.target
																.checked
														)} />
												)} />
										</SettingsSwitchContainer>

										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'conditions.services')) || null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Services</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="conditions.services"
													render={({ field }: any) => (
														<SelectAdv
															type="multi"
															options={ListServicesOptionsNoB}
															value={field.value || []}
															onChange={(options) => setFieldValue("conditions.services", options)} />
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'hours'))|| null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Applicable Hours</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<FastField
												name="conditions.hours"
												render={({ field }: any) => (
													<FieldOpeningHoursV2
													allowNone={true}
													hours={field.value}
													onChange={(opening_hours) => {
														setFieldValue("conditions", {
															//@ts-ignore
															...form.values.conditions,
															hours: opening_hours,
														});
													}}
/>
												)} />
										</SettingsFormGroupInput>
									</SettingsFormGroup>

								</>}

								{this.state.tab === '2' &&
									<div style={{padding: 16}}>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Abacus Open Item</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="abacus_open_item"
													render={({ field }: any) => (
														<SelectAdv
															type="single"
															options={openItemsList}
															value={field.value}
															onChange={(option: string) => setFieldValue("abacus_open_item", option)} />
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
									</div>}
								{this.state.tab === '3' && <>
								<SettingsFormGroup>
									<SettingsFormGroupInput
										error={(error && getFieldError(form, 'integrations.pushpos.category_id')) || null}>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>POS Category ID</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="integrations.pushpos.category_id"
												render={({ field }: any) => (
												<input
													type="number"
													{...field}
													/>
												)} />
										</SettingsFormInputContainer>
									</SettingsFormGroupInput>
									<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Assign printer for this category</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										{POS_PRINTERS.map(printer => (
										<MenuActionContainer
											className="condensed"
											key={printer.value.toString()}>
												<MenuActionItem
												onClick={() => {}}
												className="menu-printer-item">
												<div className='printer-checkbox'>
													<Checkbox
														id={printer.value.toString()}
														onChange={(e) => {
															if(e.target.checked) {
																setFieldValue(
																	'integrations.pushpos.printers',
																	Array.from(new Set([...currentAssignPOSPrinters, printer.value ]))
																)
															} else {
																setFieldValue(
																	'integrations.pushpos.printers',
																	currentAssignPOSPrinters.filter( (p: number) => p !== printer.value)
																)
															}
														}}
														checked={currentAssignPOSPrinters.includes(printer.value)}/>
													{printer.label}
												</div>

											</MenuActionItem>
										</MenuActionContainer>
										))}
									</SettingsFormGroupInput>
									{ store.isNewMenuSchema && <>
									<SettingsFormGroupInput>
										<MenuColorBodyWrapper style={{padding: 0}}>
											<MenuColorDescription>Select a color to represent this menu.</MenuColorDescription>
											<MenuColorFormGroup>
												<MenuColorLabel>Category Color</MenuColorLabel>
												<FastField
												name="integrations.pushpos.color"
												render={({ field }: any) => (
													<MenuColorColorPickerWrapper>
														<ColorPicker
															color={field.value}
															onChange={(color) => setFieldValue('integrations.pushpos.color', '#' + CoreUtils.colors.rgbToHex(color))}/>
														<MenuColorColorPickerText>{field.value}</MenuColorColorPickerText>
													</MenuColorColorPickerWrapper>
												)} />
											</MenuColorFormGroup>
											<MenuColorLabel>Pre-sets</MenuColorLabel>
											<MenuColorPresetsList>
												{PRESET_COLORS.reduce((rows: string[][], color: string, index: number) => {
												if (index % 2 === 0) {
													rows.push([color]);
												} else {
													rows[rows.length - 1].push(color);
												}
												return rows;
												}, []).map((pair: string[], rowIndex: number) => (
												<MenuColorPresetsListItem key={rowIndex}>
													{pair.map((color: string, i: number) => (
													<MenuColorPresetsListItemContent
														key={i}
														style={{ backgroundColor: color }}
														onClick={() => setFieldValue('integrations.pushpos.color', color)}
													>
														<span>{color}</span>
													</MenuColorPresetsListItemContent>
													))}
												</MenuColorPresetsListItem>
												))}

											</MenuColorPresetsList>
										</MenuColorBodyWrapper>
									</SettingsFormGroupInput></> }
								</SettingsFormGroup>
								</>}
								<SettingsActionButtonContainer>
									<SettingsActionButtonWrapper  style={{ left: 0}}>
										<button type="button"
											className="default btn-cancel"
											onClick={() => {
												store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												);
											} }>
											Cancel
										</button>
										<button type="submit" disabled={isSubmitting}>
											{isSubmitting && <RotateLoader size={2} color="white" />}
											{!isSubmitting && "Save"}
										</button>
									</SettingsActionButtonWrapper>
								</SettingsActionButtonContainer>
							</div>
						);
					} }
				</RestaurantForm>
				</>
		);

	}

}
